import React from 'react';
import { useOrgAssessmentLinkPreferencesSync } from '../hooks/useOrgAssessmentLinkPreferencesSync';

interface OrgAssessmentLinkPreferencesSyncProps {
    entityId?: string | null;
}

const OrgAssessmentLinkPreferencesSync: React.FC<OrgAssessmentLinkPreferencesSyncProps> = ({ entityId }) => {
    useOrgAssessmentLinkPreferencesSync(entityId);
    return null;
};

export default OrgAssessmentLinkPreferencesSync;
